import { Injectable } from '@angular/core';
import { QueryParams } from '../../models/Utilities/QueryParamEntity';
import * as appApiResources from '../../../shared/globalcontants';
import { UnitEntity } from '../../models/Units/UnitsEntity';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../common.service';
import { PopupComponent } from '../../popup/popup.component';
import { MatDialog } from '@angular/material/dialog';
import { OfflineService } from 'src/app/offline/offline.service';
import { Router } from '@angular/router';
import * as util from 'util';
import moment from 'moment-timezone';
import { APIServiceProviderService } from '../APIServices/APIServiceProviderService/APIServiceProviderService';
import { IngredientLocationDetail, InventoryStatusByLocationDetail, LocationListEntity, StatusLocationEntity } from '../../models/Location/LocationEntity';
import { SystemPrefModel } from '../../models/Utilities/CommonEntity';

@Injectable({ providedIn: 'root' })
export class GlobalConversionService {
  commonDetails: any;
  requisitionDetails: any;
  globalSystemPreference: Array<any> = [];
  genericReqNotSupportedMessage = 'Generic Requisition is currently not supported in Offline';
  closedFinancialPeriodDate: string = moment('01/01/1990').format();
  azureAdInfo: any;
  constructor(
    private _ts: TranslateService,
    public _CommonService: CommonService,
    private _os: OfflineService,
    private dialog: MatDialog,
    private router: Router,
    private apiServiceProviderService: APIServiceProviderService,
  ) {
    this.commonDetails = this._ts.instant('common');
    this.requisitionDetails = this._ts.instant('Requisition');
  }

  /**
  * @method UnitDetailsConversion()
  * @input ConversionKey
  * @output UnitDetails
  * @description GetUnitDetails
  */

  UnitDetailsConversion(UnitDetails: Array<UnitEntity>, ConversionKey: string, FilterKey: any, PropertyKey = 'UnitTypeId'): any {
    try {
      let returnResult = null;
      if (UnitDetails && UnitDetails.length > 0) {
        if (UnitDetails && UnitDetails.length > 0) {
          let UnitCollection: Array<UnitEntity> = UnitDetails.filter((Units: UnitEntity) => Units[PropertyKey] === FilterKey);
          if (UnitCollection && UnitCollection.length === 0) {
            UnitCollection = UnitDetails.filter((Units: UnitEntity) => Units[PropertyKey] === 1);
          }
          if (UnitCollection && UnitCollection.length > 0) {
            returnResult = UnitCollection[0][ConversionKey];
          }
        }
      }
      return returnResult;
    } catch (error) {
      console.error(error);
    }
  }

  /**
* @method UnitDetailsConversion()
* @input ConversionKey
* @output UnitDetails
* @description GetUnitDetails
*/

  UnitDetailsCollection(UnitDetails: Array<UnitEntity>, FilterKey: any, PropertyKey = 'UnitTypeId'): UnitEntity {
    try {
      let returnResult = null;
      if (UnitDetails && UnitDetails.length > 0) {
        let UnitCollection: Array<UnitEntity> = UnitDetails.filter((Units: UnitEntity) => Units[PropertyKey] === FilterKey);
        if (UnitCollection && UnitCollection.length === 0) {
          UnitCollection = UnitDetails.filter((Units: UnitEntity) => Units[PropertyKey] === 1);
        }
        if (UnitCollection && UnitCollection.length > 0) {
          returnResult = UnitCollection[0];
        }
      }
      return returnResult;
    } catch (error) {
      console.error(error);
    }
  }
  /**
   * checkSamelocationValidation
   * @param FormData 
   * @param TransationForm 
   * @returns 
   */

  checkSamelocationValidation(FormData: FormGroup, FroLocId: any, ToLocId: any, ErrorMessage: string): boolean {
    try {
      let returnValue = true;
      const formLocationId = FormData.get(FroLocId).value;
      const toLocationId = FormData.get(ToLocId).value;
      if (formLocationId && toLocationId) {
        if (formLocationId.toString() === toLocationId.toString()) {
          this.commonDetails = this._ts.instant('common');
          this.showPopUp(this.commonDetails.error, ErrorMessage, '', this.commonDetails.ok, FormData, []);
          returnValue = false; // Invalid Date
        }
      }
      return returnValue;
    } catch (error) {
      console.error(error);
    }
  }

  checkValidation(formDataControl: any, isCheck: boolean = false): boolean {
    try {
      this.commonDetails = this._ts.instant('common');
      //  if(formDataControl){
      if (isCheck) {
        if (!(formDataControl["fromLocation"].value && formDataControl["toLocation"].value) ||
          (formDataControl["fromLocation"].value.toString().length === 0 && formDataControl["toLocation"].value.toString().length === 0)) {
          this.openPopup(this.commonDetails.error, this.commonDetails.locationErrorMsg, '', this.commonDetails.ok)
          return false;
        }
        else if (Number(formDataControl["fromLocation"].value) === Number(formDataControl["toLocation"].value)) {
          this.openPopup(this.commonDetails.error, this.commonDetails.samelocationErrorMsg, '', this.commonDetails.ok)
          return false;
        }
      }
      for (let key in formDataControl) {
        let errors = formDataControl[key].errors;
        if (errors) {
          if (errors.hasOwnProperty("maxlength")) {
            this.openPopup('Error', key[0].toUpperCase() + key.slice(1) + ' length should be less than ' + errors.maxlength.requiredLength, '', 'OK')
            return false;
          }
          else if (errors.hasOwnProperty("required")) {
            if (formDataControl["projectExpensed"]?.value && !formDataControl["CapexId"]?.value) {
              this.openPopup('Error', "Fill mandatory details ", '', 'OK')
              return false;
            } else if (key === 'reqNo' && !formDataControl["reqNo"]?.value) {
              this.openPopup('Error', "Req Number  is required ", '', 'OK')
              return false;
            } else if (key === 'customerLocation' && !formDataControl["customerLocation"]?.value) {
              this.openPopup('Error', "Customer Location is required ", '', 'OK')
              return false;
            } else {
              this.openPopup('Error', key[0].toUpperCase() + key.slice(1) + ' is required ', '', 'OK')
              return false;
            }
          }
        }
      }
      //  }
      return true;
    } catch (error) {
      console.error(error);
    }
  }

  customValidation(formDataControl: any, isCheck: boolean = false): boolean {
    try {
      this.commonDetails = this._ts.instant('common');
      if (isCheck) {
        if ((!formDataControl["fromLocation"].value)) {
          this.openPopup(this.commonDetails.error, this.commonDetails.commonRequiredMsg, '', this.commonDetails.ok)
          return false;
        }
      }
      return true;
    } catch (error) {
      console.error(error);
    }
  }

  openPopup(headerText: string, contentText: string, cancelText: string, confirmText: string) {
    const dialogArray = {
      headerText: headerText,
      contentText: contentText,
      cancelText: cancelText,
      confirmText: confirmText
    };
    this._CommonService.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent,
      this._CommonService.mobilePopUpProperty
    );
    dialogRef.afterClosed().subscribe((result) => {
      this._CommonService.OpenProcessingPopUp('');
      this._CommonService.closeProcessingPopUp();

    });
  }

  /**
* @method formValidation()
* @input TableDetailsData, TransactionForm
* @output Location Url String
* @description contract the location url
*/
  async preValidation(TableData: Array<any>, TransationForm: FormGroup, detailValidation = false): Promise<boolean> {
    let isValid = true;
    this.commonDetails = this._ts.instant('common');
    this.requisitionDetails = this._ts.instant('Requisition');
    try {
      const dateDetails = this._ts.instant('dates');
      if (detailValidation) {
        if (!TableData || TableData.length === 0) {
          this.showPopUp(this.commonDetails.error, this.commonDetails.nothingToPost, '',
            this.commonDetails.ok, TransationForm, TableData);
          return isValid = false; // Nothing to post
        }
        const emptyQuantity = TableData.filter(i => i.quantity === 0 || i.quantity === '').length;
        if (emptyQuantity === TableData.length) {
          this.showPopUp(this.commonDetails.error, this.commonDetails.nothingToPost, '', this.commonDetails.ok, TransationForm, TableData);
          return isValid = false; // Nothing to post
        }
      }
      const postDate = moment(TransationForm.get('PostDate').value).format();
      // if (!util.types.isDate(postDate)) {
      //   this.showPopUp(this.commonDetails.error, dateDetails.invaliDate, '', this.commonDetails.ok, TransationForm, TableData);
      //   return isValid = false; // Invalid Date
      // }
      // const MomentDays = 'day';
      //   this.apiServiceProviderService.utilityService.EatecPreferenceSettings.SystemPreference.AllowPostingToPastDate
      // if (true) {
      //     if (moment(postDate).format('YYYY/MM/DD') < moment().format('YYYY/MM/DD')) {
      //       console.log("moment().format('YYYY/MM/DD')", moment().format('YYYY/MM/DD'))
      //       TransationForm.controls.PostDate.setErrors({});
      //       this.showPopUp(this.commonDetails.error, dateDetails.pastDateError, '', this.commonDetails.ok, TransationForm, TableData);
      //       return isValid = false;
      //     }
      //   }

      if (moment(this.closedFinancialPeriodDate).format('YYYY/MM/DD') >= moment(postDate).format('YYYY/MM/DD')) {
        this.showPopUp(this.commonDetails.error, dateDetails.commonClosedFinancialDate, '',
          this.commonDetails.ok, TransationForm, TableData);
        return isValid = false;
      }
      const selectedRequestLocationId = TransationForm.get('FromLocId').value;
      const selectedSupplyLocationId = TransationForm.get('ToLocationId').value;
      const customer = TransationForm.get('customers').value;
      const faculty = TransationForm.get('faculty').value;
      const capExProject = isNaN(parseInt(TransationForm.get('CapexId').value)) ? 0 : parseInt(TransationForm.get('CapexId').value);
      const customerOrFaculty = TransationForm.get('customerOrFaculty').value;

      if (selectedRequestLocationId.toString().length == 0 && selectedSupplyLocationId.toString().length == 0) {
        this.showPopUp(this.commonDetails.error, this.requisitionDetails.reqsupLocErrorMessage, '',
          this.commonDetails.ok, TransationForm, TableData);
        return isValid = false;
      }
      else if (selectedRequestLocationId.toString().length == 0) {
        this.showPopUp(this.commonDetails.error, this.requisitionDetails.reqLocErrorMessage, '',
          this.commonDetails.ok, TransationForm, TableData);
        return isValid = false; // Invalid FromLocation
      }
      else if (selectedSupplyLocationId.toString().length == 0) {
        this.showPopUp(this.commonDetails.error, this.requisitionDetails.supLocErrorMessage, '',
          this.commonDetails.ok, TransationForm, TableData);
        return isValid = false; // Invalid ToLocation
      }
      else if (customer?.toString().length == 0 && TransationForm.get('transferOutLocation').value && customerOrFaculty !== 2) {
        this.showPopUp(this.commonDetails.error, this.requisitionDetails.customerErrorMessage, '',
          this.commonDetails.ok, TransationForm, TableData);
        return isValid = false; // Invalid Customer
      }
      else if (faculty?.toString().length == 0 && TransationForm.get('transferOutLocation').value && customerOrFaculty === 2) {
        this.showPopUp(this.commonDetails.error, this.requisitionDetails.facultyErrorMessage, '',
          this.commonDetails.ok, TransationForm, TableData);
        return isValid = false; // Invalid Faculty
      }
      else if (selectedRequestLocationId.toString() === selectedSupplyLocationId.toString()) {
        this.showPopUp(this.commonDetails.error, this.requisitionDetails.errorMessage, '',
          this.commonDetails.ok, TransationForm, TableData);
        return isValid = false; // Invalid Date
      } else if (!capExProject && TransationForm.get('projectExpensed').value) {
        this.showPopUp(this.commonDetails.error, this.requisitionDetails.capexError, '',
          this.commonDetails.ok, TransationForm, TableData);
        return isValid = false;
      }else if (TransationForm.invalid) {
        this.showPopUp(this.commonDetails.error, this.requisitionDetails.invalid, '',
          this.commonDetails.ok, TransationForm, TableData);
        return isValid = false;
      }
    } catch (error) {
      isValid = false;
      console.error(error);
    }
    return isValid;
  }

  showPopUp(headerText: string, contentText: string, cancelText: string, confirmText: string,
    TransationForm: FormGroup, TableData: Array<any>
  ) {
    const dialogArray = {
      headerText: headerText,
      contentText: contentText,
      cancelText: cancelText,
      confirmText: confirmText
    };
    this._CommonService.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent,
      this._CommonService.mobilePopUpProperty
    );
    dialogRef.afterClosed().subscribe((result) => {
      this._CommonService.OpenProcessingPopUp('');
      if (headerText !== this.commonDetails.error && contentText !== this.genericReqNotSupportedMessage) {
        TransationForm.reset();
        TableData = [];
        if (this._CommonService.isonlineStatus) {
          if (this._CommonService.fromOfflineSync) {
            this._os.toastMessage = this.requisitionDetails.requisitionSaved;
            this.router.navigate(['/offline']);
          } else {
            this._CommonService.addQuantity = false;
            this._CommonService.currenttabIndex = 0;
            this.router.navigate(['/inventory/requisition']);
          }
        }
      }
      this._CommonService.closeProcessingPopUp();

    });
  }
  /**
   * @version 13.2 UI
   * statusByLocationConversion(LocationList, InventoryId)
   */
  statusByLocConversion(LocationData: StatusLocationEntity, InventoryId: number): IngredientLocationDetail {
    try {
      let locationList: IngredientLocationDetail = null
      if (LocationData && LocationData.hasOwnProperty('IngredientLocationDetail') && LocationData.IngredientLocationDetail.length > 0) {
        LocationData.IngredientLocationDetail.forEach((x: IngredientLocationDetail) => {
          if (x.IngredientId === InventoryId) {
            locationList = { ...x }
          }
        })
      }
      return locationList;
    } catch (error) {
      console.error(error);
    }
  }

  locationConverion(LocationData: Array<InventoryStatusByLocationDetail>): Array<LocationListEntity> {
    try {
      let locationList: Array<LocationListEntity> = []
      if (LocationData && LocationData.length > 0) {
        LocationData.forEach((x: InventoryStatusByLocationDetail) => {
          const loc = {} as LocationListEntity;
          loc.name = x.LocationName.toString();
          loc.qoh = x.QOH.toString();
          loc.minpar = x.MinPar.toString();
          loc.maxpar = x.MaxPar.toString();
          locationList.push(loc);
        })
      }
      return locationList;
    } catch (error) {
      console.error(error);
    }
  }

  currencyFormat(languageKey: string, currencyValue: any, currency:any): any {
    try {
      const currencyvisibleLength = this._CommonService.currencyvisibleLength?.toString() ?
      this._CommonService.currencyvisibleLength : 4;
      const CurrencyCode = this._CommonService.Currencies?.find(x=>x.Id == (Number(sessionStorage.getItem('BaseCurrencyId'))))?.Code;
      const cur = currency ?? CurrencyCode;
      let currenyFormat = new Intl.NumberFormat(languageKey, { style: 'currency', currency: cur ?? 'USD',
      currencyDisplay: 'narrowSymbol', minimumFractionDigits: currencyvisibleLength, maximumFractionDigits: currencyvisibleLength}).format(currencyValue);
      const code = this.CurrencySymbolJSON.find(x => x.Code == (currency || CurrencyCode))?.Symbol;
      currenyFormat = currenyFormat.replace(cur, code);
      // CurrencyDisplay: 'narrowSymbol' for Keyence US$ format
      return currenyFormat;
    } catch (error) {
      console.error(error);
    }
  }

   currencyFormatter(data: any): string {
      try {
        const returnValue = this.currencyFormat('en-IN', data, this._CommonService.Currencies?.find(x => x.Id == (Number(sessionStorage.getItem('TransactionCurrencyId')))) ? this._CommonService.Currencies?.find(x => x.Id == (Number(sessionStorage.getItem('TransactionCurrencyId'))))?.Code : this._CommonService.Currencies?.find(x => x.Id == (Number(sessionStorage.getItem('BaseCurrencyId'))))?.Code);
        return returnValue;
      } catch (error) {
        console.error(error);
      }
    }

  customformatter(number: any) {
    try {
      let formattedNumber: any;
      const decimalvisibleLength = CommonService.decimalvisibleLength?.toString() ? 
      CommonService.decimalvisibleLength : 4;
      if (number) {
        formattedNumber = parseFloat(number.toString()).toFixed(decimalvisibleLength);
      } else {
        number = 0;
        formattedNumber = parseFloat(number.toString()).toFixed(decimalvisibleLength);
      }
      return formattedNumber;
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * systemPreferenceCheck
   * @params Required SystemPreference
   * @returns boolean
   */

   systemPreferenceCheck(data : SystemPrefModel): boolean {
    try {
      return this.globalSystemPreference.find(x=>x.LookupName === data.LookupName && x.LookupValue === data.LookupValue)
    } catch (error) {
      console.error(error);
    }
  }

  systemPreferenceChecker(data : SystemPrefModel): any {
    try {
      return this.globalSystemPreference.find(x=>x.LookupName === data.LookupName)
    } catch (error) {
      console.error(error);
    }
  }

  CurrencySymbolJSON = [
      {
        "Id": 1,
        "Name": "Afghan afghani",
        "Code": "AFN",
        "Symbol": "؋"
      },
      {
        "Id": 2,
        "Name": "Albanian Lek",
        "Code": "ALL",
        "Symbol": "Lek"
      },
      {
        "Id": 3,
        "Name": "Algerian Dinar",
        "Code": "DZD",
        "Symbol": "دج"
      },
      {
        "Id": 4,
        "Name": "Angolan Kwanza",
        "Code": "AOA",
        "Symbol": "Kz"
      },
      {
        "Id": 5,
        "Name": "Antillian Guilder",
        "Code": "ANG",
        "Symbol": "ƒ"
      },
      {
        "Id": 6,
        "Name": "Armenian Dram",
        "Code": "AMD",
        "Symbol": "֏"
      },
      {
        "Id": 7,
        "Name": "Aruban Guilder",
        "Code": "AWG",
        "Symbol": "ƒ"
      },
      {
        "Id": 8,
        "Name": "Australian Dollars",
        "Code": "AUD",
        "Symbol": "$"
      },
      {
        "Id": 9,
        "Name": "Azerbaijani manat",
        "Code": "AZN",
        "Symbol": "₼"
      },
      {
        "Id": 10,
        "Name": "Bahamian Dollar",
        "Code": "BSD",
        "Symbol": "$"
      },
      {
        "Id": 11,
        "Name": "Bahraini Dinar",
        "Code": "BHD",
        "Symbol": "د.ب"
      },
      {
        "Id": 12,
        "Name": "Bangladesh Taka",
        "Code": "BDT",
        "Symbol": "৳"
      },
      {
        "Id": 13,
        "Name": "Barbados Dollar",
        "Code": "BBD",
        "Symbol": "$"
      },
      {
        "Id": 14,
        "Name": "Belize Dollar",
        "Code": "BZD",
        "Symbol": "BZ$"
      },
      {
        "Id": 15,
        "Name": "Bermudian Dollar",
        "Code": "BMD",
        "Symbol": "$"
      },
      {
        "Id": 16,
        "Name": "Bhutanese Ngultrum",
        "Code": "BTN",
        "Symbol": "Nu"
      },
      {
        "Id": 17,
        "Name": "Bolivar Fuerte",
        "Code": "ESA",
        "Symbol": "Bs"
      },
      {
        "Id": 18,
        "Name": "Bolivia Boliviano",
        "Code": "BOB",
        "Symbol": "$b"
      },
      {
        "Id": 19,
        "Name": "Bolivian Mvdol",
        "Code": "BOV",
        "Symbol": "Mvdol"
      },
      {
        "Id": 20,
        "Name": "Bosnia and Herzegovina Convertible Marks",
        "Code": "BAM",
        "Symbol": "KM"
      },
      {
        "Id": 21,
        "Name": "Botswana Pula",
        "Code": "BWP",
        "Symbol": "P"
      },
      {
        "Id": 22,
        "Name": "Brazilian Real",
        "Code": "BRL",
        "Symbol": "R$"
      },
      {
        "Id": 23,
        "Name": "Brunei Dollar",
        "Code": "BND",
        "Symbol": "$"
      },
      {
        "Id": 24,
        "Name": "Burundi Franc",
        "Code": "BIF",
        "Symbol": "FBu"
      },
      {
        "Id": 25,
        "Name": "Cambodia Riel",
        "Code": "KHR",
        "Symbol": "៛"
      },
      {
        "Id": 26,
        "Name": "Canadian Dollar",
        "Code": "CAD",
        "Symbol": "$"
      },
      {
        "Id": 27,
        "Name": "Cape Verdi Escudo",
        "Code": "CVE",
        "Symbol": "Esc"
      },
      {
        "Id": 28,
        "Name": "Cayman Islands Dollar",
        "Code": "KYD",
        "Symbol": "$"
      },
      {
        "Id": 29,
        "Name": "CFA Franc BCEAO",
        "Code": "XOF",
        "Symbol": "CFA"
      },
      {
        "Id": 30,
        "Name": "CFA Franc BEAC",
        "Code": "XAF",
        "Symbol": "FCFA"
      },
      {
        "Id": 31,
        "Name": "CFP Franc",
        "Code": "XPF",
        "Symbol": "₣"
      },
      {
        "Id": 32,
        "Name": "Chilean Peso",
        "Code": "CLP",
        "Symbol": "$"
      },
      {
        "Id": 33,
        "Name": "Chinese Yuan Renminbi",
        "Code": "CNX",
        "Symbol": "¥"
      },
      {
        "Id": 34,
        "Name": "Colombian Peso",
        "Code": "COP",
        "Symbol": "$"
      },
      {
        "Id": 35,
        "Name": "Comoro Franc",
        "Code": "KMF",
        "Symbol": "CF"
      },
      {
        "Id": 36,
        "Name": "Congolese Franc",
        "Code": "CDF",
        "Symbol": "FC"
      },
      {
        "Id": 37,
        "Name": "Costa Rican Colon",
        "Code": "CRC",
        "Symbol": "₡"
      },
      {
        "Id": 38,
        "Name": "Croatian Kuna",
        "Code": "HRK",
        "Symbol": "kn"
      },
      {
        "Id": 39,
        "Name": "Cuban convertible peso",
        "Code": "CUC",
        "Symbol": "CUC$"
      },
      {
        "Id": 40,
        "Name": "Cuban Peso",
        "Code": "CUP",
        "Symbol": "₱"
      },
      {
        "Id": 41,
        "Name": "Czech Koruna",
        "Code": "CZK",
        "Symbol": "Kč"
      },
      {
        "Id": 42,
        "Name": "Danish Krone",
        "Code": "DKK",
        "Symbol": "kr"
      },
      {
        "Id": 43,
        "Name": "Djibouti Franc",
        "Code": "DJF",
        "Symbol": "Fdj"
      },
      {
        "Id": 44,
        "Name": "Dobra",
        "Code": "STD",
        "Symbol": "Db"
      },
      {
        "Id": 45,
        "Name": "Dominican Republic Peso",
        "Code": "DOP",
        "Symbol": "RD$"
      },
      {
        "Id": 46,
        "Name": "East Caribbean Dollar",
        "Code": "XCD",
        "Symbol": "$"
      },
      {
        "Id": 47,
        "Name": "Egyptian Pound",
        "Code": "EGP",
        "Symbol": "£"
      },
      {
        "Id": 48,
        "Name": "El Salvador Colón",
        "Code": "SVC",
        "Symbol": "$"
      },
      {
        "Id": 49,
        "Name": "Eritrean Nakfa",
        "Code": "ERN",
        "Symbol": "ናቕፋ"
      },
      {
        "Id": 50,
        "Name": "Ethiopian Birr",
        "Code": "ETB",
        "Symbol": "ብር"
      },
      {
        "Id": 51,
        "Name": "Euro",
        "Code": "EUR",
        "Symbol": "€"
      },
      {
        "Id": 52,
        "Name": "Falkland Islands Pound",
        "Code": "FKP",
        "Symbol": "£"
      },
      {
        "Id": 53,
        "Name": "Fiji Dollar",
        "Code": "FJD",
        "Symbol": "$"
      },
      {
        "Id": 54,
        "Name": "Gambia Delasi",
        "Code": "GMD",
        "Symbol": "D"
      },
      {
        "Id": 55,
        "Name": "Georgian Lari",
        "Code": "GEL",
        "Symbol": "ლ"
      },
      {
        "Id": 56,
        "Name": "Ghanaian Cedi (3rd)",
        "Code": "GHS",
        "Symbol": "¢"
      },
      {
        "Id": 57,
        "Name": "Gibraltar Pound",
        "Code": "GIP",
        "Symbol": "£"
      },
      {
        "Id": 58,
        "Name": "Guatemala Quetzal",
        "Code": "GTQ",
        "Symbol": "Q"
      },
      {
        "Id": 59,
        "Name": "Guinea Franc",
        "Code": "GNF",
        "Symbol": "GFr"
      },
      {
        "Id": 60,
        "Name": "Guyanese Dollar",
        "Code": "GYD",
        "Symbol": "$"
      },
      {
        "Id": 61,
        "Name": "Haitian Gourde",
        "Code": "HTG",
        "Symbol": "G"
      },
      {
        "Id": 62,
        "Name": "Honduras Lempira",
        "Code": "HNL",
        "Symbol": "L"
      },
      {
        "Id": 63,
        "Name": "Hong Kong Dollar",
        "Code": "HKD",
        "Symbol": "$"
      },
      {
        "Id": 64,
        "Name": "Hungarian Forint",
        "Code": "HUF",
        "Symbol": "Ft"
      },
      {
        "Id": 65,
        "Name": "Iceland Krona",
        "Code": "ISK",
        "Symbol": "kr"
      },
      {
        "Id": 66,
        "Name": "Indian Rupee",
        "Code": "INR",
        "Symbol": "₹"
      },
      {
        "Id": 67,
        "Name": "Indonesian Rupiah",
        "Code": "IDR",
        "Symbol": "Rp"
      },
      {
        "Id": 68,
        "Name": "Iranian Rial",
        "Code": "IRR",
        "Symbol": "﷼"
      },
      {
        "Id": 69,
        "Name": "Iraqi Dinar",
        "Code": "IQD",
        "Symbol": "ع.د"
      },
      {
        "Id": 70,
        "Name": "Jamaican Dollar",
        "Code": "JMD",
        "Symbol": "J$"
      },
      {
        "Id": 71,
        "Name": "Japanese Yen",
        "Code": "JPY",
        "Symbol": "¥"
      },
      {
        "Id": 72,
        "Name": "Jordanian Dinar",
        "Code": "JOD",
        "Symbol": "د.ا"
      },
      {
        "Id": 73,
        "Name": "Kazakhstani Tenge",
        "Code": "KZT",
        "Symbol": "лв"
      },
      {
        "Id": 74,
        "Name": "Kenyan Shilling",
        "Code": "KES",
        "Symbol": "Ksh"
      },
      {
        "Id": 75,
        "Name": "Kuwaiti Dinar",
        "Code": "KWD",
        "Symbol": "د.ك"
      },
      {
        "Id": 76,
        "Name": "Kyrgyzstan Som",
        "Code": "KGS",
        "Symbol": "лв"
      },
      {
        "Id": 77,
        "Name": "Laos Kip",
        "Code": "LAK",
        "Symbol": "₭"
      },
      {
        "Id": 78,
        "Name": "Lebanese Pound",
        "Code": "LBP",
        "Symbol": "£"
      },
      {
        "Id": 79,
        "Name": "Lesotho Loti",
        "Code": "LSL",
        "Symbol": "M"
      },
      {
        "Id": 80,
        "Name": "Liberia Dollar",
        "Code": "LRD",
        "Symbol": "$"
      },
      {
        "Id": 81,
        "Name": "Libyan Dinar",
        "Code": "LYD",
        "Symbol": "ل.د"
      },
      {
        "Id": 82,
        "Name": "Lithuania",
        "Code": "LTL",
        "Symbol": "LTL"
      },
      {
        "Id": 83,
        "Name": "Macau Pataca",
        "Code": "MOP",
        "Symbol": "MOP$"
      },
      {
        "Id": 84,
        "Name": "Macedonian Denar",
        "Code": "MKD",
        "Symbol": "ден"
      },
      {
        "Id": 85,
        "Name": "Malagasy Ariary",
        "Code": "MGA",
        "Symbol": "Ar"
      },
      {
        "Id": 86,
        "Name": "Malawi Kwacha",
        "Code": "MWK",
        "Symbol": "MK"
      },
      {
        "Id": 87,
        "Name": "Malaysian Ringgit",
        "Code": "MYR",
        "Symbol": "RM"
      },
      {
        "Id": 88,
        "Name": "Maldives Rufiyaa",
        "Code": "MVR",
        "Symbol": "Rf"
      },
      {
        "Id": 89,
        "Name": "Manat",
        "Code": "TMT",
        "Symbol": "AZN"
      },
      {
        "Id": 90,
        "Name": "Mauritanian ouguiya",
        "Code": "MRU",
        "Symbol": "UM"
      },
      {
        "Id": 91,
        "Name": "Mauritius Rupee",
        "Code": "MUR",
        "Symbol": "₨"
      },
      {
        "Id": 92,
        "Name": "Mexican Peso",
        "Code": "MXN",
        "Symbol": "$"
      },
      {
        "Id": 93,
        "Name": "Mexican Unidad de Inversion",
        "Code": "MXV",
        "Symbol": "MXV"
      },
      {
        "Id": 94,
        "Name": "Moldovia Leu",
        "Code": "MDL",
        "Symbol": "pl"
      },
      {
        "Id": 95,
        "Name": "Mongolia Tugrik",
        "Code": "MNT",
        "Symbol": "₮"
      },
      {
        "Id": 96,
        "Name": "Moroccan Dirham",
        "Code": "MAD",
        "Symbol": "MAD"
      },
      {
        "Id": 97,
        "Name": "Mozambican Metical",
        "Code": "MZN",
        "Symbol": "MT"
      },
      {
        "Id": 98,
        "Name": "Myanmar Kyat",
        "Code": "MMK",
        "Symbol": "K"
      },
      {
        "Id": 99,
        "Name": "Namibian Dollar",
        "Code": "NAD",
        "Symbol": "N$"
      },
      {
        "Id": 100,
        "Name": "Nepalese Rupee",
        "Code": "NPR",
        "Symbol": "₨"
      },
      {
        "Id": 101,
        "Name": "New Belarusian Ruble",
        "Code": "BYN",
        "Symbol": "Br"
      },
      {
        "Id": 102,
        "Name": "New Bulgarian Lev",
        "Code": "BGN",
        "Symbol": "лв"
      },
      {
        "Id": 103,
        "Name": "New Guinea Kina",
        "Code": "PGK",
        "Symbol": "K"
      },
      {
        "Id": 104,
        "Name": "New Israeli Scheqel",
        "Code": "ILS",
        "Symbol": "₪"
      },
      {
        "Id": 105,
        "Name": "New Polish Zloty",
        "Code": "PLN",
        "Symbol": "zł"
      },
      {
        "Id": 106,
        "Name": "New Romanian Lei",
        "Code": "RON",
        "Symbol": "lei"
      },
      {
        "Id": 107,
        "Name": "New Taiwan Dollar",
        "Code": "TWD",
        "Symbol": "NT$"
      },
      {
        "Id": 108,
        "Name": "New Turkish Lira",
        "Code": "TRY",
        "Symbol": "₺"
      },
      {
        "Id": 109,
        "Name": "New Zealand Dollar",
        "Code": "NZD",
        "Symbol": "$"
      },
      {
        "Id": 110,
        "Name": "Nicaragua Cordoba Oro",
        "Code": "NIO",
        "Symbol": "C$"
      },
      {
        "Id": 111,
        "Name": "Nigerian Naira",
        "Code": "NGN",
        "Symbol": "₦"
      },
      {
        "Id": 112,
        "Name": "North Korean won",
        "Code": "KPW",
        "Symbol": "₩"
      },
      {
        "Id": 113,
        "Name": "Norwegian Krone",
        "Code": "NOK",
        "Symbol": "kr"
      },
      {
        "Id": 114,
        "Name": "Nuevo Argentine Peso",
        "Code": "ARS",
        "Symbol": "$"
      },
      {
        "Id": 115,
        "Name": "Offshore Renminbi",
        "Code": "CNH",
        "Symbol": "¥‎"
      },
      {
        "Id": 116,
        "Name": "Ouguiya",
        "Code": "MRO",
        "Symbol": "MRU"
      },
      {
        "Id": 117,
        "Name": "Pakistan Rupee",
        "Code": "PKR",
        "Symbol": "₨"
      },
      {
        "Id": 118,
        "Name": "Panamanian Balboa",
        "Code": "PAB",
        "Symbol": "B/."
      },
      {
        "Id": 119,
        "Name": "Paraguay Guarani",
        "Code": "PYG",
        "Symbol": "Gs"
      },
      {
        "Id": 120,
        "Name": "Peruvian Nuevo Sol",
        "Code": "PEN",
        "Symbol": "S/."
      },
      {
        "Id": 121,
        "Name": "Peso Uruguayo",
        "Code": "UYU",
        "Symbol": "$U"
      },
      {
        "Id": 122,
        "Name": "Philippine Peso",
        "Code": "PHP",
        "Symbol": "₱"
      },
      {
        "Id": 123,
        "Name": "British Pound Sterling",
        "Code": "GBP",
        "Symbol": "£"
      },
      {
        "Id": 124,
        "Name": "Qatari Rial",
        "Code": "QAR",
        "Symbol": "﷼"
      },
      {
        "Id": 125,
        "Name": "Reval. Belarus Ruble",
        "Code": "BYR",
        "Symbol": "Rbl‎"
      },
      {
        "Id": 126,
        "Name": "Rial Omani",
        "Code": "OMR",
        "Symbol": "﷼"
      },
      {
        "Id": 127,
        "Name": "Russian Ruble",
        "Code": "RUB",
        "Symbol": "₽"
      },
      {
        "Id": 128,
        "Name": "Rwanda Franc",
        "Code": "RWF",
        "Symbol": "FRw"
      },
      {
        "Id": 129,
        "Name": "Samoan Tala",
        "Code": "WST",
        "Symbol": "WS$"
      },
      {
        "Id": 130,
        "Name": "Sao Tome and Principe Dobra",
        "Code": "STN",
        "Symbol": "Db"
      },
      {
        "Id": 131,
        "Name": "Saudi Riyal",
        "Code": "SAR",
        "Symbol": "﷼"
      },
      {
        "Id": 132,
        "Name": "Serbian Dinar",
        "Code": "RSD",
        "Symbol": "Дин."
      },
      {
        "Id": 133,
        "Name": "Seychelles Rupee",
        "Code": "SCR",
        "Symbol": "₨"
      },
      {
        "Id": 134,
        "Name": "Sierra Leone Leone",
        "Code": "SLE",
        "Symbol": "Le"
      },
      {
        "Id": 135,
        "Name": "Sierra Leonean leone",
        "Code": "SLL",
        "Symbol": "Le"
      },
      {
        "Id": 136,
        "Name": "Singapore Dollar",
        "Code": "SGD",
        "Symbol": "$"
      },
      {
        "Id": 137,
        "Name": "Solomon Island Dollar",
        "Code": "SBD",
        "Symbol": "$"
      },
      {
        "Id": 138,
        "Name": "Somalia Shilling",
        "Code": "SOS",
        "Symbol": "S"
      },
      {
        "Id": 139,
        "Name": "South African Rand",
        "Code": "ZAR",
        "Symbol": "R"
      },
      {
        "Id": 140,
        "Name": "South Sudan Pound",
        "Code": "SSP",
        "Symbol": "£"
      },
      {
        "Id": 141,
        "Name": "South-Korean Won",
        "Code": "KRW",
        "Symbol": "₩"
      },
      {
        "Id": 142,
        "Name": "Sri Lankan Rupee",
        "Code": "LKR",
        "Symbol": "₨"
      },
      {
        "Id": 143,
        "Name": "St. Helena Pound",
        "Code": "SHP",
        "Symbol": "£"
      },
      {
        "Id": 144,
        "Name": "Sudanese pound",
        "Code": "SDG",
        "Symbol": "ج.س"
      },
      {
        "Id": 145,
        "Name": "Surinamese dollar",
        "Code": "SRD",
        "Symbol": "$"
      },
      {
        "Id": 146,
        "Name": "Swaziland Lilangeni",
        "Code": "SZL",
        "Symbol": "E"
      },
      {
        "Id": 147,
        "Name": "Swedish Krone",
        "Code": "SEK",
        "Symbol": "kr"
      },
      {
        "Id": 148,
        "Name": "Swiss Franc",
        "Code": "CHF",
        "Symbol": "CHF"
      },
      {
        "Id": 149,
        "Name": "Syrian Pound",
        "Code": "SYP",
        "Symbol": "£"
      },
      {
        "Id": 150,
        "Name": "Tajikistan Somoni",
        "Code": "TJS",
        "Symbol": "ЅM"
      },
      {
        "Id": 151,
        "Name": "Tanzanian Shilling",
        "Code": "TZS",
        "Symbol": "TSh"
      },
      {
        "Id": 153,
        "Name": "Thai Baht",
        "Code": "THB",
        "Symbol": "฿"
      },
      {
        "Id": 154,
        "Name": "Tonga Paanga",
        "Code": "TOP",
        "Symbol": "T$"
      },
      {
        "Id": 155,
        "Name": "Trinidad & Tobago Dollar",
        "Code": "TTD",
        "Symbol": "TT$"
      },
      {
        "Id": 156,
        "Name": "Tunisian Dinar",
        "Code": "TND",
        "Symbol": "د.ت"
      },
      {
        "Id": 157,
        "Name": "Emirati UAE Dirham",
        "Code": "AED",
        "Symbol": " د.إ"
      },
      {
        "Id": 158,
        "Name": "Uganda Shilling",
        "Code": "UGX",
        "Symbol": "USh"
      },
      {
        "Id": 159,
        "Name": "Ukraine Hryvnia",
        "Code": "UAH",
        "Symbol": "₴"
      },
      {
        "Id": 160,
        "Name": "Unidad de Fomento",
        "Code": "CLF",
        "Symbol": "CLF"
      },
      {
        "Id": 161,
        "Name": "Unidad de Valor Real",
        "Code": "COU",
        "Symbol": "UVR"
      },
      {
        "Id": 162,
        "Name": "United States dollar (next day) ",
        "Code": "USN",
        "Symbol": "$"
      },
      {
        "Id": 163,
        "Name": "Uruguay Peso en Unidades Indexadas",
        "Code": "UYI",
        "Symbol": "$U‎"
      },
      {
        "Id": 164,
        "Name": "US Dollars",
        "Code": "USD",
        "Symbol": "$"
      },
      {
        "Id": 165,
        "Name": "Uzbekistani Som",
        "Code": "UZS",
        "Symbol": "лв"
      },
      {
        "Id": 166,
        "Name": "Vanuatu Vatu",
        "Code": "VUV",
        "Symbol": "VT"
      },
      {
        "Id": 167,
        "Name": "Venezuelan Bolívar",
        "Code": "VEF",
        "Symbol": "Bs"
      },
      {
        "Id": 168,
        "Name": "Venezuelan digital bolivar",
        "Code": "VED",
        "Symbol": "Bs."
      },
      {
        "Id": 169,
        "Name": "Venezuelan sovereign bolivar",
        "Code": "VES",
        "Symbol": "VES"
      },
      {
        "Id": 170,
        "Name": "Vietnamese New Dong",
        "Code": "VND",
        "Symbol": "₫"
      },
      {
        "Id": 171,
        "Name": "WIR Euro",
        "Code": "CHE",
        "Symbol": "€"
      },
      {
        "Id": 172,
        "Name": "WIR franc",
        "Code": "CHW",
        "Symbol": "CHW"
      },
      {
        "Id": 173,
        "Name": "Yemeni Rial",
        "Code": "YER",
        "Symbol": "﷼"
      },
      {
        "Id": 174,
        "Name": "Yuan Renminbi",
        "Code": "CNY",
        "Symbol": "¥"
      },
      {
        "Id": 175,
        "Name": "Zambian Kwacha",
        "Code": "ZMW",
        "Symbol": "ZK"
      },
      {
        "Id": 176,
        "Name": "Zimbabwean dollar",
        "Code": "ZWL",
        "Symbol": "Z$"
      }
    ];
}
